export enum COVERAGE_TYPES {
  GET_COVERAGELIST_REQUEST = '@openClaim/GET_COVERAGELIST_REQUEST',
  SET_DATA_COVERAGELIST = '@openClaim/SET_DATA_COVERAGELIST',
  GET_COVERAGELIST_BY_TYPE_PDV_REQUEST = '@openClaim/GET_COVERAGELIST_BY_TYPE_PDV_REQUEST',
}
interface SubCoverage extends Coverage {
  description: string;
  help: string[];
}

export interface Coverage {
  id: number;
  name: string;
  subCoverage: SubCoverage[];
}

export interface CoverageState {
  coverageList: Coverage[];
}
